// @flow

import type {Blokk} from '../../components/enblokksvisning/Blokk'

import {partier} from '../../data'

function mapDataToProps(data: any) {
  const blokker: Blokk[] = data.blokker.map((d, idx) => {
    return {
      id: String(idx),
      statsministerkandidat: {
        navn: {
          fullt: partier[d.lederparti].partilederNavn
        }
      },
      statsministerkandidatBilde: partier[d.lederparti].bilde,
      lederParti: d.lederparti,
      partier: d.partier.map(p => {
        return {
          kortNavn: p.kode,
          antallMandater: p.mandater
        }
      }),
      totaltAntallMandater: d.partier.reduce((sum, p) => sum + p.mandater, 0)
    }
  })

  return {
    blokker,
    id: data.id,
    title: data.title || 'Mandatfordeling i ulike konstellasjoner',
    description: data.description,
    source:
      data.source || 'Basert på meningsmåling fra Norstat for NRK, august 2017'
  }
}

export default mapDataToProps



// WEBPACK FOOTER //
// ./src/shared/containers/EnblokksvisningWidget/mapDataToProps.js